<div *ngIf="showTeams" class="row">
  <!-- ngif (currentProjectSelection != null && currentRoleSelection.roletypeid == roletypeenum.coder)  -->
  <div class="col-md-12 text-center">
    <h1 class="title" style="color:black">Select Active Team</h1>
  </div>
</div>
<div *ngIf="showTeams" class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card">
      <div class="card-body">
        <div class="col-md-12">
          <div *ngIf="hasTeams" class="col-md-12">
            <mat-radio-group name="teamSelectList" aria-label="Select a team" [(ngModel)]="currentTeamSelection">
              <div *ngFor="let team of availableTeams">
                <mat-radio-button name="teamSelectList" [value]="team.value" (change)="onTeamChange()">
                  {{team.title}}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div *ngIf="!hasTeams" class="col-md-12 text-center">
            No teams currently available
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<br />
<!-- ngif (currentRoleSelection != null && currentRoleSelection.roletypeid == roletypeenum.admin) || (currentProjectSelection != null && currentRoleSelection.roletypeid == roletypeenum.supervisor)  || (currentTeamSelection != null) -->
<div *ngIf="showSubmit" class="row">
  <div class="col-md-4 offset-md-6">
    <button type="button" class="btn btn-primary" (click)="submitReconTeamSelection()" [disabled]="authService.updatingTokenInProgress">Submit</button>
  </div>
</div>
